import { ActionCreators } from "redux-undo";
import {
	initCanvasAPI,
	initClipboardAPI,
	initGuidesAPI,
	initPageAPI,
	initSelectionAPI,
} from "./store/actionCreators/index";
import { initStore } from "./store/ReduxRegistry";

export const initApp = (initialState?: any, isPrimaryInstance = false) => {
	const canvasStore = initStore(initialState, isPrimaryInstance);

	const page = initPageAPI(canvasStore.dispatch);
	const selection = initSelectionAPI(canvasStore.dispatch);
	const canvas = initCanvasAPI(canvasStore.dispatch);
	const clipboard = initClipboardAPI(canvasStore.dispatch);
	const guides = initGuidesAPI(canvasStore.dispatch);

	return {
		canvas,
		canvasStore,
		clipboard,
		guides,
		page,
		selection,
		undoRedo: {
			clear: () => canvasStore.dispatch(ActionCreators.clearHistory()),
			redo: () => canvasStore.dispatch(ActionCreators.redo()),
			undo: () => canvasStore.dispatch(ActionCreators.undo()),
		},
	};
};
